import React from 'react';
import {Stack, Typography} from '@mui/material';
import {PaymentSection} from 'app/components/sharedReactComponents/PaymentForm/PaymentSection';
import {CouponState} from 'app/components/BillingManager/hooks/useCoupon';
import {BaseBilling, formatCouponError} from 'app/components/entities/billing/base';
import {ValidateCoupon} from 'app/components/features/billing/coupons';
import {CouponDetails, CouponIcon} from 'app/components/entities/billing/coupons';
import {StyleSx} from 'app/types/common';

const textSx: StyleSx = {mt: 0.5, ml: '50px'};

interface Props {
  hasConnect: boolean;
  state: CouponState;
  setCoupon: (value: string) => void;
  onValidate: (value: string) => Promise<void>;
}

export function PaymentFormCoupon({hasConnect, state, setCoupon, onValidate}: Props) {
  return (
    <PaymentSection
      className="payment-form-coupon"
      data-id="payment_info_coupon_form"
      title="Voucher"
    >
      <ValidateCoupon state={state} onChange={setCoupon} onValidate={onValidate} />

      {state.type === 'invalid' && (
        <Stack mt={2} direction="row" alignItems="center" gap={1}>
          <CouponIcon valid={false} />
          <Typography data-id="coupon-error" color="error.main">
            {formatCouponError(state.error)}
          </Typography>
        </Stack>
      )}

      {state.type === 'typing' && (
        <Typography data-id="coupon-note" mt={1} color="error.main">
          To apply voucher it must be validated
        </Typography>
      )}

      {state.type === 'valid' && (
        <>
          <Stack mt={2} direction="row" alignItems="center" gap={1}>
            <CouponIcon valid={true} />
            <CouponDetails coupon={state.instance} />
          </Stack>

          <Typography sx={textSx} data-id="coupon-note">
            {getNoteMessage(state.instance, hasConnect)}
          </Typography>
        </>
      )}
    </PaymentSection>
  );
}

function getNoteMessage(coupon: BaseBilling.Coupon, hasConnect: boolean) {
  if (coupon.is_ibb) {
    return 'This voucher assumes billing based on invoices.';
  }

  if (coupon.product === 'connect' && !hasConnect) {
    return 'By activating this Epiphan Connect coupon you will be subscribed to Epiphan Connect Pro plan';
  }

  return 'The voucher will apply to your next invoice.';
}
